import { React, useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";

import classes from './AppHdWithCloseRight.module.css'
import { IconX } from '@tabler/icons-react';

const AppHdWithCloseRight = (props) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
            };
            window.addEventListener('resize', handleResize);
            return () => {
            window.removeEventListener('resize', handleResize);
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const goBack = () => {
        navigate(-1)
    }

    return(
        <>
        {isMobile ? (
            <div className={classes.appHeading}>
            
                <div className={classes.navbackBlank}/>
                <div className={classes.navtitle}>
                    <h2>{props.children}</h2>
                </div>
        
                <div >
                    <button className={classes.btn} 
                        onClick={goBack}>
                        <IconX />
                </button>
                </div>
            </div>
        ) : (
            <div className={classes.appHeading}>
                <div className={classes.navbackBlank}/>
                <div className={classes.navtitle}>
                    <h2>{props.children}</h2>
                </div>

                <div >
                    <button className={classes.btn}
                        onClick={goBack}>
                        <IconX />
                </button>
                </div>
            </div>
        )
        
        }
        
        </>

    )
}

export default AppHdWithCloseRight;